export const token = (state) => state.token;
export const tokenRequests = (state) => state.tokenRequests;
export const deals = (state) => state.deals;
export const pageInfo = (state) => state.pageInfo;
export const dealsPageInfo = (state) => state.dealsPageInfo;
export const dealMembers = (state) => state.dealMembers;
export const tokenTransactions = (state) => state.tokenTransactions;
export const pages = (state) => state.pages;
export const page = (state) => state.page;
export const totalTransactions = (state) => state.totalTransactions;
export const dealInvestors = (state) => state.dealInvestors;
export const members = (state) => state.members;
export const dealroomMembers = (state) => state.dealroomMembers;
export const dealroomWaitlist = (state) => state.dealroomWaitlist;
export const allDealRoomMembers = (state) => state.allDealRoomMembers;

// getters from investor-base
export const userTokens = (state) => state.userTokens?.filter((token)=> token.currency === "NGN");
export const userDealRooms = (state) => state.userDealRooms;
export const ongoingTokens = (state) => state.ongoingTokens;
export const completedTokens = (state) => state.completedTokens;
export const privateTokens = (state) => state.privateTokens;
export const orderBook = (state) => state.orderBook;
export const publicTokens = (state) => state.publicTokens;
export const tokenInfo = (state) => state.tokenInfo;
export const assetInfo = (state) => state.assetInfo;
export const tokenBalance = (state) => state.tokenBalance;
export const tokenPayoutDetails = (state) => state.tokenPayoutDetails;
export const dealRoomInfo = (state) => state.dealRoomInfo;
export const tokenUpdates = (state) => state.tokenUpdates;
export const subscriptionStatus = (state) => state.subscriptionStatus;
export const subscriptionPlans = (state) => state.subscriptionPlans;
export const orgInfo = (state) => state.orgInfo;
export const companiesRaising = (state) => state.raisingTokens;
export const raisingPage = (state) => state.raisingPage;
export const raisingPages = (state) => state.raisingPages;
export const certificateInfo = (state) => state.certificateInfo;
export const badgeInfo = (state) => state.badgeInfo;
export const membershipStatus = (state) => state.membershipStatus;
